"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSaveStagedChangesRequestStatus = exports.getStagedROISetting = exports.getStagedCostPerLead = exports.hasErrors = exports.getStagedChangesCount = void 0;

var _reselect = require("reselect");

var _StagingActions = require("../actions/StagingActions");

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _selectors = require("settings-ui-sdk/AdsROI/selectors");

var _constants = require("../constants");

var getStagedObjects = function getStagedObjects(state) {
  return state.modules.marketing.ads.staging;
};

var getStagedChangesCount = (0, _reselect.createSelector)(getStagedObjects, _selectors.getDesiredCostPerLead, function (stagedObjects) {
  // For now, since there are only two fields to the estimated cost per lead setting,
  // just treat any change here as 1 change.
  if (!stagedObjects.get('stagedCostPerLead').equals(stagedObjects.get('currentCostPerLead')) || stagedObjects.get('stagedROISetting') !== stagedObjects.get('currentROISetting')) {
    return 1;
  } else {
    return 0;
  }
});
exports.getStagedChangesCount = getStagedChangesCount;
var hasErrors = (0, _reselect.createSelector)(getStagedObjects, function (stagedObjects) {
  var stagedCostPerLead = stagedObjects.get('stagedCostPerLead');
  return stagedObjects.get('stagedROISetting') === _constants.ROI_TYPE.LEAD_COST_ROI && (!stagedCostPerLead.avgSalePrice || !stagedCostPerLead.leadCloseRatePercent || stagedCostPerLead.leadCloseRatePercent.toString().indexOf('.') > -1);
});
exports.hasErrors = hasErrors;
var getStagedCostPerLead = (0, _reselect.createSelector)(getStagedObjects, function (stagedObjects) {
  return stagedObjects.get('stagedCostPerLead');
});
exports.getStagedCostPerLead = getStagedCostPerLead;
var getStagedROISetting = (0, _reselect.createSelector)(getStagedObjects, function (stagedObjects) {
  return stagedObjects.get('stagedROISetting');
});
exports.getStagedROISetting = getStagedROISetting;
var getSaveStagedChangesRequestStatus = (0, _getRequestStatus.default)(_StagingActions.StagingActionTypes.SAVE_STAGED_CHANGES);
exports.getSaveStagedChangesRequestStatus = getSaveStagedChangesRequestStatus;